// GENERATED FILE — written by scripts/gen-art.mjs. Do not hand-edit.
//
// Every image in this project comes from Nano Banana (see art/README.md). This
// map is how a finished render reaches the app: the generator writes an entry
// here for each file it produces, and the components that can show generated
// art look themselves up in it.
//
// The point is that there is no second step to forget. Before this existed,
// wiring a batch up meant remembering to add ids to three different lists by
// hand, and an id added before its PNG existed meant a 404 on every render —
// so the list is now written by the only thing that knows what actually
// landed on disk.
//
// An id that isn't here keeps its drawn SVG fallback, which is why a
// half-generated batch degrades to something correct rather than to holes.

export const GENERATED_ART: Record<string, string> = {
  'advent': '/road/advent.jpg',
  'amos': '/skins/amos.png',
  'amos_asking': '/skins/amos_asking.png',
  'amos_settled': '/skins/amos_settled.png',
  'amos_struck': '/skins/amos_struck.png',
  'aquinas': '/skins/aquinas.png',
  'arcade_page': '/arcade/arcade_page.jpg',
  'arcade_wilderness': '/arcade/arcade_wilderness.jpg',
  'arcade_workshop': '/arcade/arcade_workshop.jpg',
  'armor_of_god': '/skins/armor_of_god.png',
  'bethlehem_star_bearer': '/skins/bethlehem_star_bearer.png',
  'bride': '/skins/bride.png',
  'bride_asking': '/skins/bride_asking.png',
  'bride_settled': '/skins/bride_settled.png',
  'bride_struck': '/skins/bride_struck.png',
  'cephas': '/skins/cephas.png',
  'cephas_asking': '/skins/cephas_asking.png',
  'cephas_settled': '/skins/cephas_settled.png',
  'cephas_struck': '/skins/cephas_struck.png',
  'cg_approved': '/keep/cg_approved.jpg',
  'cg_draft': '/keep/cg_draft.jpg',
  'cg_private': '/keep/cg_private.jpg',
  'cg_study': '/keep/cg_study.jpg',
  'cg_week': '/keep/cg_week.jpg',
  'chest_closed': '/keep/chest_closed.png',
  'chest_open': '/keep/chest_open.png',
  'church_classic_basilica': '/church/church_classic_basilica.png',
  'church_classic_cathedral': '/church/church_classic_cathedral.png',
  'church_classic_chapel': '/church/church_classic_chapel.png',
  'church_classic_country': '/church/church_classic_country.png',
  'church_classic_gathering': '/church/church_classic_gathering.png',
  'church_classic_great': '/church/church_classic_great.png',
  'church_classic_parish': '/church/church_classic_parish.png',
  'church_classic_stone': '/church/church_classic_stone.png',
  'church_glass_basilica': '/church/church_glass_basilica.png',
  'church_glass_cathedral': '/church/church_glass_cathedral.png',
  'church_glass_chapel': '/church/church_glass_chapel.png',
  'church_glass_country': '/church/church_glass_country.png',
  'church_glass_gathering': '/church/church_glass_gathering.png',
  'church_glass_great': '/church/church_glass_great.png',
  'church_glass_parish': '/church/church_glass_parish.png',
  'church_glass_stone': '/church/church_glass_stone.png',
  'church_modern_basilica': '/church/church_modern_basilica.png',
  'church_modern_cathedral': '/church/church_modern_cathedral.png',
  'church_modern_chapel': '/church/church_modern_chapel.png',
  'church_modern_country': '/church/church_modern_country.png',
  'church_modern_gathering': '/church/church_modern_gathering.png',
  'church_modern_great': '/church/church_modern_great.png',
  'church_modern_parish': '/church/church_modern_parish.png',
  'church_modern_stone': '/church/church_modern_stone.png',
  'church_tile_basilica': '/church/church_tile_basilica.png',
  'church_tile_cathedral': '/church/church_tile_cathedral.png',
  'church_tile_chapel': '/church/church_tile_chapel.png',
  'church_tile_country': '/church/church_tile_country.png',
  'church_tile_gathering': '/church/church_tile_gathering.png',
  'church_tile_great': '/church/church_tile_great.png',
  'church_tile_parish': '/church/church_tile_parish.png',
  'church_tile_stone': '/church/church_tile_stone.png',
  'churchyard': '/church/churchyard.jpg',
  'cpu_deacon': '/skins/cpu_deacon.png',
  'cpu_prophet': '/skins/cpu_prophet.png',
  'cpu_rookie': '/skins/cpu_rookie.png',
  'cross_beam': '/items/cross_beam.png',
  'daniel': '/skins/daniel.png',
  'daniel_asking': '/skins/daniel_asking.png',
  'daniel_settled': '/skins/daniel_settled.png',
  'daniel_struck': '/skins/daniel_struck.png',
  'david_asking': '/skins/david_asking.png',
  'david_settled': '/skins/david_settled.png',
  'david_struck': '/skins/david_struck.png',
  'deborah': '/skins/deborah.png',
  'eden': '/skins/eden.png',
  'elijah': '/skins/elijah.png',
  'ezekiel': '/skins/ezekiel.png',
  'ezekiel_asking': '/skins/ezekiel_asking.png',
  'ezekiel_settled': '/skins/ezekiel_settled.png',
  'ezekiel_struck': '/skins/ezekiel_struck.png',
  'francis': '/skins/francis.png',
  'habakkuk': '/skins/habakkuk.png',
  'habakkuk_asking': '/skins/habakkuk_asking.png',
  'habakkuk_settled': '/skins/habakkuk_settled.png',
  'habakkuk_struck': '/skins/habakkuk_struck.png',
  'haggai': '/skins/haggai.png',
  'haggai_asking': '/skins/haggai_asking.png',
  'haggai_settled': '/skins/haggai_settled.png',
  'haggai_struck': '/skins/haggai_struck.png',
  'harvest_reaper': '/skins/harvest_reaper.png',
  'hildegard': '/skins/hildegard.png',
  'hosea': '/skins/hosea.png',
  'hosea_asking': '/skins/hosea_asking.png',
  'hosea_settled': '/skins/hosea_settled.png',
  'hosea_struck': '/skins/hosea_struck.png',
  'isaiah': '/skins/isaiah.png',
  'isaiah_asking': '/skins/isaiah_asking.png',
  'isaiah_settled': '/skins/isaiah_settled.png',
  'isaiah_struck': '/skins/isaiah_struck.png',
  'james': '/skins/james.png',
  'james_asking': '/skins/james_asking.png',
  'james_settled': '/skins/james_settled.png',
  'james_struck': '/skins/james_struck.png',
  'jeremiah': '/skins/jeremiah.png',
  'jeremiah_asking': '/skins/jeremiah_asking.png',
  'jeremiah_settled': '/skins/jeremiah_settled.png',
  'jeremiah_struck': '/skins/jeremiah_struck.png',
  'jesus': '/skins/jesus.png',
  'jesus_asking': '/skins/jesus_asking.png',
  'jesus_settled': '/skins/jesus_settled.png',
  'jesus_struck': '/skins/jesus_struck.png',
  'job': '/skins/job.png',
  'job_asking': '/skins/job_asking.png',
  'job_settled': '/skins/job_settled.png',
  'job_struck': '/skins/job_struck.png',
  'joel': '/skins/joel.png',
  'joel_asking': '/skins/joel_asking.png',
  'joel_settled': '/skins/joel_settled.png',
  'joel_struck': '/skins/joel_struck.png',
  'john': '/skins/john.png',
  'john_asking': '/skins/john_asking.png',
  'john_settled': '/skins/john_settled.png',
  'john_struck': '/skins/john_struck.png',
  'jonah': '/skins/jonah.png',
  'jonah_asking': '/skins/jonah_asking.png',
  'jonah_settled': '/skins/jonah_settled.png',
  'jonah_struck': '/skins/jonah_struck.png',
  'jonathan': '/skins/jonathan.png',
  'joseph': '/skins/joseph.png',
  'joshua': '/skins/joshua.png',
  'joshua_asking': '/skins/joshua_asking.png',
  'joshua_settled': '/skins/joshua_settled.png',
  'joshua_struck': '/skins/joshua_struck.png',
  'jude': '/skins/jude.png',
  'jude_asking': '/skins/jude_asking.png',
  'jude_settled': '/skins/jude_settled.png',
  'jude_struck': '/skins/jude_struck.png',
  'keep_armor_rack': '/keep/keep_armor_rack.png',
  'keep_barrels': '/keep/keep_barrels.png',
  'keep_brazier': '/keep/keep_brazier.png',
  'keep_chandelier': '/keep/keep_chandelier.png',
  'keep_chess': '/keep/keep_chess.png',
  'keep_crossed_spears': '/keep/keep_crossed_spears.png',
  'keep_destrier': '/keep/keep_destrier.png',
  'keep_lanterns': '/keep/keep_lanterns.png',
  'keep_oil_lamp': '/keep/keep_oil_lamp.png',
  'keep_sheaf_banner': '/keep/keep_sheaf_banner.png',
  'keep_tapestry': '/keep/keep_tapestry.png',
  'keep_woven_rug': '/keep/keep_woven_rug.png',
  'lamplight': '/road/lamplight.jpg',
  'lamplighter': '/skins/lamplighter.png',
  'lantern': '/skins/lantern.png',
  'librarian': '/skins/librarian.png',
  'luke': '/skins/luke.png',
  'luke_asking': '/skins/luke_asking.png',
  'luke_settled': '/skins/luke_settled.png',
  'luke_struck': '/skins/luke_struck.png',
  'magus': '/skins/magus.png',
  'malachi': '/skins/malachi.png',
  'malachi_asking': '/skins/malachi_asking.png',
  'malachi_settled': '/skins/malachi_settled.png',
  'malachi_struck': '/skins/malachi_struck.png',
  'mary': '/skins/mary.png',
  'melisende': '/skins/melisende.png',
  'micah': '/skins/micah.png',
  'micah_asking': '/skins/micah_asking.png',
  'micah_settled': '/skins/micah_settled.png',
  'micah_struck': '/skins/micah_struck.png',
  'mordecai': '/skins/mordecai.png',
  'mordecai_asking': '/skins/mordecai_asking.png',
  'mordecai_settled': '/skins/mordecai_settled.png',
  'mordecai_struck': '/skins/mordecai_struck.png',
  'moses_asking': '/skins/moses_asking.png',
  'moses_settled': '/skins/moses_settled.png',
  'moses_struck': '/skins/moses_struck.png',
  'nahum': '/skins/nahum.png',
  'nahum_asking': '/skins/nahum_asking.png',
  'nahum_settled': '/skins/nahum_settled.png',
  'nahum_struck': '/skins/nahum_struck.png',
  'naomi': '/skins/naomi.png',
  'naomi_asking': '/skins/naomi_asking.png',
  'naomi_settled': '/skins/naomi_settled.png',
  'naomi_struck': '/skins/naomi_struck.png',
  'nehemiah': '/skins/nehemiah.png',
  'nehemiah_asking': '/skins/nehemiah_asking.png',
  'nehemiah_settled': '/skins/nehemiah_settled.png',
  'nehemiah_struck': '/skins/nehemiah_struck.png',
  'olive_keeper': '/skins/olive_keeper.png',
  'open_bible': '/keep/open_bible.png',
  'overlay_pillar': '/items/overlay_pillar.png',
  'overlay_refuge': '/items/overlay_refuge.png',
  'overlay_vine': '/items/overlay_vine.png',
  'paul': '/skins/paul.png',
  'paul_asking': '/skins/paul_asking.png',
  'paul_settled': '/skins/paul_settled.png',
  'paul_struck': '/skins/paul_struck.png',
  'pet_camel': '/items/pet_camel.png',
  'pet_donkey': '/items/pet_donkey.png',
  'pet_dove': '/items/pet_dove.png',
  'pet_lamb': '/items/pet_lamb.png',
  'pet_lion_cub': '/items/pet_lion_cub.png',
  'pet_raven': '/items/pet_raven.png',
  'porchlight': '/skins/porchlight.png',
  'prayer-wall': '/keep/prayer-wall.jpg',
  'prophet_elder': '/skins/prophet_elder.png',
  'prophet_elder_asking': '/skins/prophet_elder_asking.png',
  'prophet_elder_settled': '/skins/prophet_elder_settled.png',
  'prophet_elder_struck': '/skins/prophet_elder_struck.png',
  'prophet_young': '/skins/prophet_young.png',
  'prophet_young_asking': '/skins/prophet_young_asking.png',
  'prophet_young_settled': '/skins/prophet_young_settled.png',
  'prophet_young_struck': '/skins/prophet_young_struck.png',
  'room-1': '/room/room-1.jpg',
  'room-2': '/room/room-2.jpg',
  'room-3': '/room/room-3.jpg',
  'room-4': '/room/room-4.jpg',
  'room-5': '/room/room-5.jpg',
  'room_cedar_chest': '/keep/room_cedar_chest.png',
  'room_censer': '/keep/room_censer.png',
  'room_clay_lamps': '/keep/room_clay_lamps.png',
  'room_dovecote': '/keep/room_dovecote.png',
  'room_hanging': '/keep/room_hanging.png',
  'room_land_map': '/keep/room_land_map.png',
  'room_lattice': '/keep/room_lattice.png',
  'room_loom': '/keep/room_loom.png',
  'room_olive_jar': '/keep/room_olive_jar.png',
  'room_open_scroll': '/keep/room_open_scroll.png',
  'room_palm_wreath': '/keep/room_palm_wreath.png',
  'room_psaltery': '/keep/room_psaltery.png',
  'room_reed_mat': '/keep/room_reed_mat.png',
  'room_scroll_rack': '/keep/room_scroll_rack.png',
  'room_sleeping_mat': '/keep/room_sleeping_mat.png',
  'room_stool': '/keep/room_stool.png',
  'room_water_jar': '/keep/room_water_jar.png',
  'rosary': '/keep/rosary.png',
  'samuel': '/skins/samuel.png',
  'samuel_asking': '/skins/samuel_asking.png',
  'samuel_settled': '/skins/samuel_settled.png',
  'samuel_struck': '/skins/samuel_struck.png',
  'scribe': '/skins/scribe.png',
  'scribe_asking': '/skins/scribe_asking.png',
  'scribe_settled': '/skins/scribe_settled.png',
  'scribe_struck': '/skins/scribe_struck.png',
  'sharkey': '/skins/sharkey.png',
  'shepherd_night': '/skins/shepherd_night.png',
  'solomon': '/skins/solomon.png',
  'solomon_asking': '/skins/solomon_asking.png',
  'solomon_settled': '/skins/solomon_settled.png',
  'solomon_struck': '/skins/solomon_struck.png',
  'starter_fem_amber_ash': '/skins/starter_fem_amber_ash.png',
  'starter_fem_amber_auburn': '/skins/starter_fem_amber_auburn.png',
  'starter_fem_amber_chestnut': '/skins/starter_fem_amber_chestnut.png',
  'starter_fem_amber_espresso': '/skins/starter_fem_amber_espresso.png',
  'starter_fem_amber_honey': '/skins/starter_fem_amber_honey.png',
  'starter_fem_amber_jet': '/skins/starter_fem_amber_jet.png',
  'starter_fem_bronze_ash': '/skins/starter_fem_bronze_ash.png',
  'starter_fem_bronze_auburn': '/skins/starter_fem_bronze_auburn.png',
  'starter_fem_bronze_chestnut': '/skins/starter_fem_bronze_chestnut.png',
  'starter_fem_bronze_espresso': '/skins/starter_fem_bronze_espresso.png',
  'starter_fem_bronze_honey': '/skins/starter_fem_bronze_honey.png',
  'starter_fem_bronze_jet': '/skins/starter_fem_bronze_jet.png',
  'starter_fem_ebony': '/skins/starter_fem_ebony.png',
  'starter_fem_ebony_ash': '/skins/starter_fem_ebony_ash.png',
  'starter_fem_ebony_auburn': '/skins/starter_fem_ebony_auburn.png',
  'starter_fem_ebony_chestnut': '/skins/starter_fem_ebony_chestnut.png',
  'starter_fem_ebony_espresso': '/skins/starter_fem_ebony_espresso.png',
  'starter_fem_ebony_honey': '/skins/starter_fem_ebony_honey.png',
  'starter_fem_ebony_jet': '/skins/starter_fem_ebony_jet.png',
  'starter_fem_porcelain_ash': '/skins/starter_fem_porcelain_ash.png',
  'starter_fem_porcelain_auburn': '/skins/starter_fem_porcelain_auburn.png',
  'starter_fem_porcelain_chestnut': '/skins/starter_fem_porcelain_chestnut.png',
  'starter_fem_porcelain_espresso': '/skins/starter_fem_porcelain_espresso.png',
  'starter_fem_porcelain_honey': '/skins/starter_fem_porcelain_honey.png',
  'starter_fem_porcelain_jet': '/skins/starter_fem_porcelain_jet.png',
  'starter_fem_sand': '/skins/starter_fem_sand.png',
  'starter_fem_sand_ash': '/skins/starter_fem_sand_ash.png',
  'starter_fem_sand_auburn': '/skins/starter_fem_sand_auburn.png',
  'starter_fem_sand_chestnut': '/skins/starter_fem_sand_chestnut.png',
  'starter_fem_sand_espresso': '/skins/starter_fem_sand_espresso.png',
  'starter_fem_sand_honey': '/skins/starter_fem_sand_honey.png',
  'starter_fem_sand_jet': '/skins/starter_fem_sand_jet.png',
  'starter_fem_umber_ash': '/skins/starter_fem_umber_ash.png',
  'starter_fem_umber_auburn': '/skins/starter_fem_umber_auburn.png',
  'starter_fem_umber_chestnut': '/skins/starter_fem_umber_chestnut.png',
  'starter_fem_umber_espresso': '/skins/starter_fem_umber_espresso.png',
  'starter_fem_umber_honey': '/skins/starter_fem_umber_honey.png',
  'starter_fem_umber_jet': '/skins/starter_fem_umber_jet.png',
  'starter_masc_amber_ash': '/skins/starter_masc_amber_ash.png',
  'starter_masc_amber_auburn': '/skins/starter_masc_amber_auburn.png',
  'starter_masc_amber_chestnut': '/skins/starter_masc_amber_chestnut.png',
  'starter_masc_amber_espresso': '/skins/starter_masc_amber_espresso.png',
  'starter_masc_amber_honey': '/skins/starter_masc_amber_honey.png',
  'starter_masc_amber_jet': '/skins/starter_masc_amber_jet.png',
  'starter_masc_bronze_ash': '/skins/starter_masc_bronze_ash.png',
  'starter_masc_bronze_auburn': '/skins/starter_masc_bronze_auburn.png',
  'starter_masc_bronze_chestnut': '/skins/starter_masc_bronze_chestnut.png',
  'starter_masc_bronze_espresso': '/skins/starter_masc_bronze_espresso.png',
  'starter_masc_bronze_honey': '/skins/starter_masc_bronze_honey.png',
  'starter_masc_bronze_jet': '/skins/starter_masc_bronze_jet.png',
  'starter_masc_ebony': '/skins/starter_masc_ebony.png',
  'starter_masc_ebony_ash': '/skins/starter_masc_ebony_ash.png',
  'starter_masc_ebony_auburn': '/skins/starter_masc_ebony_auburn.png',
  'starter_masc_ebony_chestnut': '/skins/starter_masc_ebony_chestnut.png',
  'starter_masc_ebony_espresso': '/skins/starter_masc_ebony_espresso.png',
  'starter_masc_ebony_honey': '/skins/starter_masc_ebony_honey.png',
  'starter_masc_ebony_jet': '/skins/starter_masc_ebony_jet.png',
  'starter_masc_porcelain': '/skins/starter_masc_porcelain.png',
  'starter_masc_porcelain_ash': '/skins/starter_masc_porcelain_ash.png',
  'starter_masc_porcelain_auburn': '/skins/starter_masc_porcelain_auburn.png',
  'starter_masc_porcelain_chestnut': '/skins/starter_masc_porcelain_chestnut.png',
  'starter_masc_porcelain_espresso': '/skins/starter_masc_porcelain_espresso.png',
  'starter_masc_porcelain_honey': '/skins/starter_masc_porcelain_honey.png',
  'starter_masc_porcelain_jet': '/skins/starter_masc_porcelain_jet.png',
  'starter_masc_sand': '/skins/starter_masc_sand.png',
  'starter_masc_sand_ash': '/skins/starter_masc_sand_ash.png',
  'starter_masc_sand_auburn': '/skins/starter_masc_sand_auburn.png',
  'starter_masc_sand_chestnut': '/skins/starter_masc_sand_chestnut.png',
  'starter_masc_sand_espresso': '/skins/starter_masc_sand_espresso.png',
  'starter_masc_sand_honey': '/skins/starter_masc_sand_honey.png',
  'starter_masc_sand_jet': '/skins/starter_masc_sand_jet.png',
  'starter_masc_umber_ash': '/skins/starter_masc_umber_ash.png',
  'starter_masc_umber_auburn': '/skins/starter_masc_umber_auburn.png',
  'starter_masc_umber_chestnut': '/skins/starter_masc_umber_chestnut.png',
  'starter_masc_umber_espresso': '/skins/starter_masc_umber_espresso.png',
  'starter_masc_umber_honey': '/skins/starter_masc_umber_honey.png',
  'starter_masc_umber_jet': '/skins/starter_masc_umber_jet.png',
  'statue_angel': '/keep/statue_angel.png',
  'statue_david': '/keep/statue_david.png',
  'statue_dove': '/keep/statue_dove.png',
  'statue_lion_lamb': '/keep/statue_lion_lamb.png',
  'statue_mary': '/keep/statue_mary.png',
  'statue_moses': '/keep/statue_moses.png',
  'statue_shepherd': '/keep/statue_shepherd.png',
  'statue_tomb': '/keep/statue_tomb.png',
  'story_listeners': '/skins/story_listeners.png',
  'streak_100': '/keep/streak_100.png',
  'streak_1000': '/keep/streak_1000.png',
  'streak_3': '/keep/streak_3.png',
  'streak_30': '/keep/streak_30.png',
  'streak_365': '/keep/streak_365.png',
  'streak_7': '/keep/streak_7.png',
  'study-library': '/keep/study-library.jpg',
  'study_satchel': '/keep/study_satchel.png',
  'watchman': '/skins/watchman.png',
  'wise_lamp': '/skins/wise_lamp.png',
  'yard_bench': '/keep/yard_bench.png',
  'yard_birdbath': '/keep/yard_birdbath.png',
  'yard_dogwood': '/keep/yard_dogwood.png',
  'yard_hedge': '/keep/yard_hedge.png',
  'yard_ivy': '/keep/yard_ivy.png',
  'yard_lamp': '/keep/yard_lamp.png',
  'yard_lavender': '/keep/yard_lavender.png',
  'yard_lilies': '/keep/yard_lilies.png',
  'yard_marigolds': '/keep/yard_marigolds.png',
  'yard_olive': '/keep/yard_olive.png',
  'yard_planters': '/keep/yard_planters.png',
  'yard_rosebush': '/keep/yard_rosebush.png',
  'yard_sunflowers': '/keep/yard_sunflowers.png',
  'yard_wisteria': '/keep/yard_wisteria.png',
  'zechariah': '/skins/zechariah.png',
  'zechariah_asking': '/skins/zechariah_asking.png',
  'zechariah_settled': '/skins/zechariah_settled.png',
  'zechariah_struck': '/skins/zechariah_struck.png',
}
